<div class="condition-viewer">

  <div class="condition-row">
    <div class="leftMargin">
      <div class="topLeft"></div>
      <div class="bottomLeft"></div>
      <div class="my-operator {{type}}" *ngIf="!first">{{operator}}</div>
    </div>
  </div>

  <div class="condition-row">
    <div class="leftMargin">
      <div class="topLeft"></div>
      <div class="topRight"></div>
      <div class="bottomLeft" *ngIf="!last"></div>
    </div>
    <div class="factor-list">
      <gen-factor-viewer *ngFor="let factor of condition.factors"
                         class="factor-editor-panel"
                         [factor]="factor"
      ></gen-factor-viewer>
    </div>
  </div>

</div>
